module.exports = __webpack_public_path__ + "static/arri-09fadd3b8e117e9d4bc2ce14f902108e.png";